import moment from "moment";

export function getScheduleDisplay(
  scheduledFor: moment.MomentInput,
  timePreference: string | undefined
): string {
  const displayDateFormat =
    timePreference === "12h" ? "ddd D MMM h:mma" : "ddd D MMM HH:mm";
  return moment(scheduledFor).format(displayDateFormat);
}
